import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Input from "../UI/Input/Input";
import Button from "../UI/Button/Button";

import {
  IntroductionPageWrapper,
  IntroductionPageLogo,
  IntroductionPageDescription,
  IntrodutionPageActionWrapper,
  IntroductionPageActionButtons,
} from "./IntroductionPage.styled";

const IntroductionPage = () => {
  const [inputValue, setInputValue] = useState("");
  const navigate = useNavigate();

  const getInputValue = (value) => {
    setInputValue(value);
  };

  const handleSubmitClick = () => {
    if (inputValue) {
      localStorage.setItem("userName", inputValue);
      navigate("/", { replace: true });
    } else {
      console.log("input should not to be empty");
    }
  };

  const handleSkipClick = () => {
    localStorage.setItem("skippedIntro", true);
    navigate("/", { replace: true });
  };

  return (
    <>
      <IntroductionPageWrapper>
        <IntroductionPageLogo>Todo App</IntroductionPageLogo>
        <IntrodutionPageActionWrapper>
          <span>Let's get acquainted!</span>
          <span>
            Provide your name in the input below <i>OR</i> you can skip it if
            you want to be anonymus
          </span>
          <Input
            title="Note: Only latin letters"
            getInputValue={getInputValue}
          />
          <IntroductionPageActionButtons>
            <Button text="SUBMIT" success onClick={handleSubmitClick} />
            <Button text="SKIP" danger onClick={handleSkipClick} />
          </IntroductionPageActionButtons>
        </IntrodutionPageActionWrapper>
        <IntroductionPageDescription>
          Simplicity in your daily tasks managing
        </IntroductionPageDescription>
      </IntroductionPageWrapper>
    </>
  );
};

export default IntroductionPage;
